// Copied from flobi-flow src/lib/modelTasks.js (518142c9, 13 Oct) so Director's Generate drawer reads a model exactly as Flow's
// prompt bar does. Keep in step with Flow: change it there first, then copy it here.
/**
 * The jobs a model DECLARES it does — ai-back's catalogue field `tasks`
 * (2026-10-02) on every `ai.models.list` row:
 *
 *   video.reference  video.keyframe  video.edit  video.motion
 *   video.talking    video.translate
 *   audio.speech     audio.music     audio.sfx
 *   text
 *
 * The rule every reader follows: a model with tasks is placed by them and
 * nothing else; a model whose `tasks` is empty (every model from before the
 * field) is placed exactly as before, by the hard-coded rules of the reader
 * (lib/videoTasks, lib/audioTasks, the Playground panes, the text picker).
 * So a NEW model needs no code — its row says what it does.
 *
 * Pure: no React, no store.
 */

/**
 * The tasks Flow has a place for today. ai-back declares more (video.extend,
 * video.upscale, audio.split, text.transcribe…) for nodes not built yet; a
 * model that declares ONLY such tasks is in no picker until its node exists.
 */
export const FLOW_TASKS = new Set([
  "video.reference", "video.keyframe", "video.edit", "video.motion",
  "video.talking", "video.translate",
  "audio.speech", "audio.music", "audio.sfx",
  "text",
]);

/**
 * The model's declared tasks that Flow places, or null when it declares none
 * (place it the old way). [] — truthy — when it declares tasks but none Flow
 * has a node for: every reader then leaves it out.
 */
export function declaredTasks(m) {
  const t = m?.tasks;
  if (!Array.isArray(t)) return null;
  const all = t.filter((x) => typeof x === "string" && x);
  if (!all.length) return null;
  return all.filter((x) => FLOW_TASKS.has(x));
}

/**
 * The model's declared tasks of one family ("video" | "audio"), without the
 * family: ["reference", "edit"] for ["video.reference", "video.edit"]. Null
 * when it declares nothing at all (the old rules decide); [] when it declares
 * tasks but none of this family — it is not a model of that kind, and no
 * picker of that kind lists it.
 */
export function declaredIn(m, family) {
  const t = declaredTasks(m);
  if (!t) return null;
  const p = `${family}.`;
  return t.filter((x) => x.startsWith(p)).map((x) => x.slice(p.length));
}

/** Does the model declare this task ("text", "video.edit"…)? False when it declares none. */
export const declares = (m, task) => !!declaredTasks(m)?.includes(task);
